
import { ReactNode, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface NavigationHandlerProps {
  children: ReactNode;
}

const NavigationHandler = ({ children }: NavigationHandlerProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Handle back navigation when Escape key is pressed
      if (event.key === 'Escape' || event.key === 'Backspace') {
        // Only trigger back navigation if we're not in an input field
        const activeElement = document.activeElement as HTMLElement;
        const isInputActive = ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement?.tagName || '');
        const isContentEditable = activeElement?.hasAttribute('contenteditable');
        
        if (!isInputActive && !isContentEditable && location.pathname !== '/') {
          event.preventDefault();
          navigate(-1);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    
    // Clean up the event listener when component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate, location]);

  return <>{children}</>;
};

export default NavigationHandler;
